import * as React from 'react';
import { addSlash } from '../../utils';
const Links = ({ data }) => {
  switch (data.layout) {
    case 'List':
      return (
        <div
          key={data.layout}
          className="w-full link-list flex flex-row justify-start items-start flex-nowrap container col-span-12 mx-auto"
          style={{
            backgroundColor: data.background_color ? data.background_color : 'transparent',
          }}
        >
          {data.link.map((link) => {
            return (
              <div
                key={link.image.url}
                className="flex flex-col items-center link-item w-full md:w-1/3"
              >
                {link.image && (
                  <div className="image-wrapper w-full">
                    <img src={link.image.url} className="w-full h-full object-contain" />
                  </div>
                )}
                {link.url && link.urltext && (
                  <span>
                    <a href={addSlash(link.url)} className="link-link">
                      {link.urltext}
                    </a>
                  </span>
                )}
              </div>
            );
          })}
        </div>
      );
    default:
      return (
        <div
          className="w-full links flex flex-col md:flex-row flex-nowrap col-span-12 mx-auto"
          style={{
            backgroundColor: data.background_color ? data.background_color : 'transparent',
          }}
        >
          {data.link.map((link) => {
            return (
              <div
                key={link.image?.url || link?.url}
                className="flex flex-col items-center link-item"
              >
                {link.image && (
                  <div className="image-wrapper w-full">
                    <img src={link.image.url} className="w-full h-full object-contain" />
                  </div>
                )}
                {link.url && link.urltext && (
                  <span>
                    <a href={addSlash(link.url)} className="link-link">
                      {link.urltext}
                    </a>
                  </span>
                )}
              </div>
            );
          })}
        </div>
      );
  }
};

export default Links;
